import { loadStripe } from "@stripe/stripe-js";
import { purchaseSubscription, purchaseCredits, SubscriptionType, FrequencyType, CreditsSize, CreditsType, CandleType, CandleColour, purchaseCandle } from "@services/paymentService";
import { getAnalyticsIds } from "@util/ga";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

export const redirectToSubscriptionCheckout = async (
    subscriptionType: SubscriptionType,
    frequency: FrequencyType,
    coupon?: string,
): Promise<void> => {
    try {
        // Call API service to create subscription and get session ID
        const sessionId = await purchaseSubscription(subscriptionType, frequency, coupon);

        // Initialize Stripe and redirect to checkout
        const stripe = await stripePromise;
        if (stripe && sessionId) {
            await stripe.redirectToCheckout({ sessionId });
        } else {
            throw new Error("Stripe initialization or sessionId retrieval failed.");
        }
    } catch (error) {
        console.error("Failed to initiate subscription checkout.", error);
        throw error;
    }
};

export const redirectToCreditsCheckout = async (
    creditsType: CreditsType,
    creditsSize: CreditsSize,
    memorialId?: string, // Provide for upgrading a memorial
    serviceId?: string, // Provide for creating memorial from service
)
: Promise<void> => {
    try {
        // Call API service to create credits purchase and get session ID
        // GA IDs let the server record the purchase once Stripe confirms payment
        const analytics = await getAnalyticsIds();
        const sessionId = await purchaseCredits(
            creditsType, creditsSize, memorialId, serviceId, analytics,
        );

        // Initialize Stripe and redirect to checkout
        const stripe = await stripePromise;
        if (stripe && sessionId) {
            await stripe.redirectToCheckout({ sessionId });
        } else {
            throw new Error("Stripe initialization or sessionId retrieval failed.");
        }
    } catch (error) {
        console.error("Failed to initiate credits checkout.", error);
        throw error;
    }
};

export const redirectToCandleCheckout = async (
    candleType: CandleType,
    candleColour: CandleColour,
    memorialId: string,
)
: Promise<void> => {
    try {
        // Call API service to create credits purchase and get session ID
        const sessionId = await purchaseCandle(candleType, candleColour, memorialId);

        // Initialize Stripe and redirect to checkout
        const stripe = await stripePromise;
        if (stripe && sessionId) {
            await stripe.redirectToCheckout({ sessionId });
        } else {
            throw new Error("Stripe initialization or sessionId retrieval failed.");
        }
    } catch (error) {
        console.error("Failed to initiate credits checkout.", error);
        throw error;
    }
};
